const team = [
    {
        name:"Shivansh Khare",
        title:"Android Developer",
        image:"images/dummy.png",
        url:"https://www.linkedin.com/in/shivansh-khare-88292618b/",

    },
    {
        name:"Harsh Dubey",
        title:"Full Stack Developer",
        image:"images/dummy.png",
        url:"https://www.linkedin.com/in/harsh-dubey11/",

    },
    {
        name:"Anubhav Singh",
        title:"DevOps Engineer",
        image:"images/dummy.png",
        url:"https://www.linkedin.com/in/anubhavsinghgtm/",

    },
    {
        name:"Prakhar Saxena",
        title:"Android Developer",
        image:"images/dummy.png",
        url:"https://www.linkedin.com/in/prakhar-saxena-2985741b1/",

    },
    {
        name:"Prateek Agarwal",
        title:"ML Engineer",
        image:"images/dummy.png",
        url:"https://www.linkedin.com/in/prateek-agarwal-790719167/",

    }
    
];

export default team;